<template lang="pug">
router-link.ui.icon.button.tiny(
  :to="{name: 'drive/file', params: { inode_id: inode.id} }"
)
  slot {{ inode.name | truncate(30) }}
</template>

<script>
export default {
  name: "PhotoBreadcrumb",
  props: { inode: { type: Object, required: true } },
}
</script>

<style scoped></style>
